import { createTuyau } from '@tuyau/core/client'
import { createTuyauReactQueryClient } from '@tuyau/react-query'
import { registry } from 'gozoki-backend/registry'
import { leaveSessionOnUnauthorized } from '~/lib/refused-session'
import { getToken } from '~/utils/api'

// Shared by every Tuyau client of the back-office (Lucie, Product Management).
export const JSON_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json, text/plain, */*',
}

export const attachAdminToken = async (request: Request) => {
  const token = await getToken()
  if (token) request.headers.set('Authorization', `Bearer ${token}`)
}

export const tuyauClient = createTuyau({
  baseUrl: import.meta.env.VITE_BACKEND_API_ENDPOINT,
  registry,
  // ky defaults to a 10s request timeout, which is too short for slow endpoints
  // (e.g. the Unify camera sync). Align with the legacy axios client, which used
  // 120s for every request.
  timeout: 120_000,
  headers: JSON_HEADERS,
  hooks: { beforeRequest: [attachAdminToken], afterResponse: [leaveSessionOnUnauthorized] },
})

export const api = createTuyauReactQueryClient({ client: tuyauClient })
